import axios from 'axios'

export interface IEnterpriseInfo {
	naf: string
	raisonSociale: string
}

export class EnterpriseService {

	private options: any = {
		baseURL: `https://recherche-entreprises.api.gouv.fr/`,
		withCredentials: false,
		headers: { 'Content-Type': 'application/json' }
	}

	private provider: any = axios.create(this.options)

	public async getBySiren(siren: string): Promise<IEnterpriseInfo> {
		if (!siren) return Promise.reject()

		let vm = this
		let cleanSiren: string = siren.replace(/\s/g, '')

		return this.provider.get('search', {params: {q: cleanSiren, page: 1, per_page: 1}})
		.then((response: any) => {
			let results: any[] = response.data && response.data.results
			if (!results || results.length === 0) return Promise.reject()

			let company: any = results[0]
			let naf: string = (company.siege && company.siege.activite_principale) || company.activite_principale || ''
			// L'API nous  renvoie le code NAF au format « 86.90E »  je retire le point (« 8690E »)
			naf = naf.replace(/\./g, '')

			return Promise.resolve({
				naf: naf,
				raisonSociale: company.nom_raison_sociale || company.nom_complet || ''
			})
		})
		.catch((error: any) => {
			return vm.manageError(error)
		})
	}

	private manageError(error: any): Promise<any> {
		return Promise.reject()
	}

}
